import React, {useEffect, useRef, useState} from 'react'
import useNavigation from '../../../../hooks/useNavigation'
import useQueryCommentDetail from '../../../../hooks/api/comment/useQueryCommentDetail'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import DeleteCommentModal from './DeleteCommentModal'
import TextArea from '../../../../components/input/TextArea'
import {postEditComment} from '../../../../apis/comment/editComment'

interface IProps {
    className?: string
    commentId?: string
}

const CommentDetailContainer: React.FC<IProps> = ({className, commentId}) => {
    const {goCommentList} = useNavigation()
    const {data: commentData} = useQueryCommentDetail(commentId)

    const [commentText, setCommentText] = useState('')

    useEffect(() => {
        setCommentText(commentData?.content)
    }, [commentData])

    const deleteCommentModalRef = useRef<any>()

    const onClickEditComment = async () => {
        const {data} = await postEditComment(commentData?.id, commentText)
        if (data?.success) {
            alert('Edit Comment Complete')
            goCommentList()
        }
    }
    return (
        <>
            <div className={'flex items-center justify-between md:flex-col-reverse md:gap-y-[20px]'}>
                <div
                    className={
                        'flex space-x-[60px] md:text-left md:w-full md:space-x-0 md:gap-x-[30px] sm:flex-col sm:gap-y-[20px]'
                    }>
                    <div>
                        <Text className={'text-ti2 text-font03'}>Comment ID</Text>
                        <Text className={''}>{commentData?.id}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font03'}>User ID</Text>
                        <Text className={''}>{commentData?.user_id}</Text>
                    </div>
                </div>
                <div className={'space-x-[10px] md:text-right md:w-full'}>
                    <WizButton
                        type={'primary'}
                        text={'Link'}
                        onClick={() => window.open(`https://leagueoftraders.io/ko/post/${commentData?.parent_id}`)}
                    />
                    <WizButton type={'red'} text={'Delete'} onClick={() => deleteCommentModalRef?.current.show()} />
                </div>
            </div>
            <div className={'mt-[30px] space-y-[5px]'}>
                <Text className={'text-ti2 text-font03'}>Comment</Text>
                <div>
                    <TextArea
                        value={commentText}
                        onChanged={text => setCommentText(text)}
                        textAreaClassName={'h-[200px] shadow-normal'}></TextArea>
                </div>
            </div>
            <div className={'text-center mt-[30px]'}>
                <WizButton text={'Edit Comment'} size={'big'} onClick={() => onClickEditComment()} />
            </div>
            <DeleteCommentModal deleteData={commentData} ref={deleteCommentModalRef} />
        </>
    )
}

export default CommentDetailContainer
